import { FilterCategoryController } from "./category.controller";

angular
    .module("thor.shared.filter.category.component", [])
    .component("thorFilterCategory", {
        bindings: {
            field: "=",
            category: "="
        },
        controller: FilterCategoryController,
        controllerAs: "filterCategoryCtrl",
        template: require("../../shared/filter/category.html")
    });
